import { render, staticRenderFns } from "./AppBuyer.vue?vue&type=template&id=bd7c867a"
import script from "./AppBuyer.vue?vue&type=script&lang=js"
export * from "./AppBuyer.vue?vue&type=script&lang=js"
import style0 from "./AppBuyer.vue?vue&type=style&index=0&id=bd7c867a&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports